var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgUserWaiting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C16.7614 4 19 6.23858 19 9C19 11.7614 16.7614 14 14 14C11.2386 14 9 11.7614 9 9C9 6.23858 11.2386 4 14 4ZM14 2C10.134 2 7 5.13401 7 9C7 12.866 10.134 16 14 16C17.866 16 21 12.866 21 9C21 5.13401 17.866 2 14 2ZM11 20H13V18H11C7.13401 18 4 21.134 4 25V30H6V25C6 22.2386 8.23858 20 11 20ZM22 16C18.134 16 15 19.134 15 23C15 26.866 18.134 30 22 30C25.866 30 29 26.866 29 23C29 19.134 25.866 16 22 16ZM22 18C19.2386 18 17 20.2386 17 23C17 25.7614 19.2386 28 22 28C24.7614 28 27 25.7614 27 23C27 20.2386 24.7614 18 22 18ZM21 23.4033L23.9369 26.417L25.2837 25.1669L22.7837 22.6619V19H21V23.4033Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgUserWaiting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-waiting.aa67c35093131b545d80226df724955a.svg";